// @flow
// Libs
import React from 'react'

// Components
import Spinner from 'react-spinkit'

// Style
import { white } from 'fc-styles/src/colors'

// Types
type Props = {
  enabled: boolean,
  style: Object,
  spinnerName: string,
}

const componentStyle = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  position: 'absolute',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  backgroundColor: white(0.7),
}

export default function Mask (props: Props): ?React.Element<any> {
  if (props.enabled) {
    return (
      <div data-test='Mask' style={{...componentStyle, ...props.style}}>
        <Spinner name={props.spinnerName} />
      </div>
    )
  }

  return null
}
